import httpManager from "@/app/shared/utils/httpManager";

export async function fetchLoggedBusiness() {
  const response = await httpManager.get("/settings/customer/");
  return response.data;
}
